import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/shared/auth';
import { TimePage } from '@/time/pages';

export const Route = createFileRoute('/time/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: TimeRoute
});

function TimeRoute() {
  return (
    <TimePage />
  );
}
